<template>
    <div id="vip-comment-month">
        <div class="headline ma-3 text-color-vip bold">
            VIP COMMENT BÀI VIẾT INSTAGRAM THÁNG
        </div>
        <div class="container-tabs">
            <v-tabs
                :background-color="COLOR.BG_MAIN_COLOR"
            >
                <v-tab href="#create-process" active-class="text-color-vip">Tạo tiến trình</v-tab>
                <v-tab href="#list"  active-class="text-color-vip">Danh sách VIP</v-tab>
                <v-tab href="#activity-log"  active-class="text-color-vip">Nhật ký chạy VIP</v-tab>
                <v-tab-item value="create-process">
                    <VipCommentMonthCreateProcess />
                </v-tab-item>
                <v-tab-item value="list">
                    <VipCommentMonthList />
                </v-tab-item>
                <v-tab-item value="activity-log">
                    <VipLikeCloneActivityLog :seeding_type="26"/>
                </v-tab-item>
            </v-tabs>
        </div>
    </div>
</template>

<script>
  import VipCommentMonthCreateProcess from "~/components/vip-comment-instagram-month/VipCommentMonthCreateProcess";
  import VipLikeCloneActivityLog from "~/components/vip-like-instagram-month/VipLikeCloneActivityLog";
  import VipCommentMonthList from "~/components/vip-comment-instagram-month/VipCommentMonthList";
  import {COLOR} from "~/config/constant";

  export default {
    components: {
        VipCommentMonthCreateProcess,
        VipLikeCloneActivityLog,
        VipCommentMonthList
    },
    data() {
        return {
            COLOR: COLOR
        }
    },

};
</script>
<style lang="scss">
    @import "../../scss/main";
    #vip-comment-month {
        .text-color{
            color: $mainColor;
            font-weight: bold;
        }
        .v-tabs-slider-wrapper{
            color: $vip !important;
        }
        .text-color-vip{
            color: $vip;
            font-weight: bold;
        }
    }
</style>
